import React from 'react'
import { KidsTagIcon } from '@assets/index'
import './KidsTag.scss'
import classNames from 'classnames'
import { KidsTagVariant } from '@enums/profile.enum'

interface KidsTagProps {
  color?: string
  variant?: KidsTagVariant
}

export const KidsTag = ({ color, variant = KidsTagVariant.DEFAULT }: KidsTagProps) => {
  return (
    <div className={classNames('kids-tag', { 'kids-tag-menu': variant === KidsTagVariant.MENU })}>
      <KidsTagIcon style={{ color: color }} />
    </div>
  )
}
